module.exports = __webpack_public_path__ + "img/img1_1.405f3611.jpeg";